import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, ContentChildren, Output, Inject } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { PROPERTY_TOKEN_buttons, PROPERTY_TOKEN_toolbarItems, PROPERTY_TOKEN_items } from 'devextreme-angular/core/tokens';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoAutocompleteAnimationComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteAnimationComponent extends NestedOption {
    get hide() {
      return this._getOption('hide');
    }
    set hide(value) {
      this._setOption('hide', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteAnimationComponent,
      selectors: [["dxo-autocomplete-animation"]],
      inputs: {
        hide: "hide",
        show: "show"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteAnimationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteAnimationModule = /*#__PURE__*/(() => {
  class DxoAutocompleteAnimationModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteAnimationComponent]
    });
  }
  return DxoAutocompleteAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteAtComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteAtComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'at';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteAtComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteAtComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteAtComponent,
      selectors: [["dxo-autocomplete-at"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteAtComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteAtComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteAtModule = /*#__PURE__*/(() => {
  class DxoAutocompleteAtModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteAtModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteAtModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteAtModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteAtComponent]
    });
  }
  return DxoAutocompleteAtModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteBoundaryOffsetComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteBoundaryOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'boundaryOffset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteBoundaryOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteBoundaryOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteBoundaryOffsetComponent,
      selectors: [["dxo-autocomplete-boundary-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteBoundaryOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteBoundaryOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteBoundaryOffsetModule = /*#__PURE__*/(() => {
  class DxoAutocompleteBoundaryOffsetModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteBoundaryOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteBoundaryOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteBoundaryOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteBoundaryOffsetComponent]
    });
  }
  return DxoAutocompleteBoundaryOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiAutocompleteButtonComponent = /*#__PURE__*/(() => {
  class DxiAutocompleteButtonComponent extends CollectionNestedOption {
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get _optionPath() {
      return 'buttons';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiAutocompleteButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAutocompleteButtonComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiAutocompleteButtonComponent,
      selectors: [["dxi-autocomplete-button"]],
      inputs: {
        location: "location",
        name: "name",
        options: "options"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_buttons,
        useExisting: DxiAutocompleteButtonComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiAutocompleteButtonComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiAutocompleteButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiAutocompleteButtonModule = /*#__PURE__*/(() => {
  class DxiAutocompleteButtonModule {
    /** @nocollapse */static ɵfac = function DxiAutocompleteButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAutocompleteButtonModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiAutocompleteButtonModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiAutocompleteButtonComponent]
    });
  }
  return DxiAutocompleteButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteCollisionComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteCollisionComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'collision';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteCollisionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteCollisionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteCollisionComponent,
      selectors: [["dxo-autocomplete-collision"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteCollisionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteCollisionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteCollisionModule = /*#__PURE__*/(() => {
  class DxoAutocompleteCollisionModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteCollisionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteCollisionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteCollisionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteCollisionComponent]
    });
  }
  return DxoAutocompleteCollisionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteDropDownOptionsComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteDropDownOptionsComponent extends NestedOption {
    set _toolbarItemsContentChildren(value) {
      this.setChildren('toolbarItems', value);
    }
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get animation() {
      return this._getOption('animation');
    }
    set animation(value) {
      this._setOption('animation', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get deferRendering() {
      return this._getOption('deferRendering');
    }
    set deferRendering(value) {
      this._setOption('deferRendering', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get dragAndResizeArea() {
      return this._getOption('dragAndResizeArea');
    }
    set dragAndResizeArea(value) {
      this._setOption('dragAndResizeArea', value);
    }
    get dragEnabled() {
      return this._getOption('dragEnabled');
    }
    set dragEnabled(value) {
      this._setOption('dragEnabled', value);
    }
    get dragOutsideBoundary() {
      return this._getOption('dragOutsideBoundary');
    }
    set dragOutsideBoundary(value) {
      this._setOption('dragOutsideBoundary', value);
    }
    get enableBodyScroll() {
      return this._getOption('enableBodyScroll');
    }
    set enableBodyScroll(value) {
      this._setOption('enableBodyScroll', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get fullScreen() {
      return this._getOption('fullScreen');
    }
    set fullScreen(value) {
      this._setOption('fullScreen', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hideOnOutsideClick() {
      return this._getOption('hideOnOutsideClick');
    }
    set hideOnOutsideClick(value) {
      this._setOption('hideOnOutsideClick', value);
    }
    get hideOnParentScroll() {
      return this._getOption('hideOnParentScroll');
    }
    set hideOnParentScroll(value) {
      this._setOption('hideOnParentScroll', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get maxHeight() {
      return this._getOption('maxHeight');
    }
    set maxHeight(value) {
      this._setOption('maxHeight', value);
    }
    get maxWidth() {
      return this._getOption('maxWidth');
    }
    set maxWidth(value) {
      this._setOption('maxWidth', value);
    }
    get minHeight() {
      return this._getOption('minHeight');
    }
    set minHeight(value) {
      this._setOption('minHeight', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onHidden() {
      return this._getOption('onHidden');
    }
    set onHidden(value) {
      this._setOption('onHidden', value);
    }
    get onHiding() {
      return this._getOption('onHiding');
    }
    set onHiding(value) {
      this._setOption('onHiding', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onResize() {
      return this._getOption('onResize');
    }
    set onResize(value) {
      this._setOption('onResize', value);
    }
    get onResizeEnd() {
      return this._getOption('onResizeEnd');
    }
    set onResizeEnd(value) {
      this._setOption('onResizeEnd', value);
    }
    get onResizeStart() {
      return this._getOption('onResizeStart');
    }
    set onResizeStart(value) {
      this._setOption('onResizeStart', value);
    }
    get onShowing() {
      return this._getOption('onShowing');
    }
    set onShowing(value) {
      this._setOption('onShowing', value);
    }
    get onShown() {
      return this._getOption('onShown');
    }
    set onShown(value) {
      this._setOption('onShown', value);
    }
    get onTitleRendered() {
      return this._getOption('onTitleRendered');
    }
    set onTitleRendered(value) {
      this._setOption('onTitleRendered', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get resizeEnabled() {
      return this._getOption('resizeEnabled');
    }
    set resizeEnabled(value) {
      this._setOption('resizeEnabled', value);
    }
    get restorePosition() {
      return this._getOption('restorePosition');
    }
    set restorePosition(value) {
      this._setOption('restorePosition', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get shading() {
      return this._getOption('shading');
    }
    set shading(value) {
      this._setOption('shading', value);
    }
    get shadingColor() {
      return this._getOption('shadingColor');
    }
    set shadingColor(value) {
      this._setOption('shadingColor', value);
    }
    get showCloseButton() {
      return this._getOption('showCloseButton');
    }
    set showCloseButton(value) {
      this._setOption('showCloseButton', value);
    }
    get showTitle() {
      return this._getOption('showTitle');
    }
    set showTitle(value) {
      this._setOption('showTitle', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get titleTemplate() {
      return this._getOption('titleTemplate');
    }
    set titleTemplate(value) {
      this._setOption('titleTemplate', value);
    }
    get toolbarItems() {
      return this._getOption('toolbarItems');
    }
    set toolbarItems(value) {
      this._setOption('toolbarItems', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wrapperAttr() {
      return this._getOption('wrapperAttr');
    }
    set wrapperAttr(value) {
      this._setOption('wrapperAttr', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    positionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'dropDownOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'positionChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteDropDownOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteDropDownOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteDropDownOptionsComponent,
      selectors: [["dxo-autocomplete-drop-down-options"]],
      contentQueries: function DxoAutocompleteDropDownOptionsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_toolbarItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toolbarItemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        animation: "animation",
        container: "container",
        contentTemplate: "contentTemplate",
        deferRendering: "deferRendering",
        disabled: "disabled",
        dragAndResizeArea: "dragAndResizeArea",
        dragEnabled: "dragEnabled",
        dragOutsideBoundary: "dragOutsideBoundary",
        enableBodyScroll: "enableBodyScroll",
        focusStateEnabled: "focusStateEnabled",
        fullScreen: "fullScreen",
        height: "height",
        hideOnOutsideClick: "hideOnOutsideClick",
        hideOnParentScroll: "hideOnParentScroll",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onHidden: "onHidden",
        onHiding: "onHiding",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        onShowing: "onShowing",
        onShown: "onShown",
        onTitleRendered: "onTitleRendered",
        position: "position",
        resizeEnabled: "resizeEnabled",
        restorePosition: "restorePosition",
        rtlEnabled: "rtlEnabled",
        shading: "shading",
        shadingColor: "shadingColor",
        showCloseButton: "showCloseButton",
        showTitle: "showTitle",
        tabIndex: "tabIndex",
        title: "title",
        titleTemplate: "titleTemplate",
        toolbarItems: "toolbarItems",
        visible: "visible",
        width: "width",
        wrapperAttr: "wrapperAttr"
      },
      outputs: {
        heightChange: "heightChange",
        positionChange: "positionChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteDropDownOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteDropDownOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteDropDownOptionsModule = /*#__PURE__*/(() => {
  class DxoAutocompleteDropDownOptionsModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteDropDownOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteDropDownOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteDropDownOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteDropDownOptionsComponent]
    });
  }
  return DxoAutocompleteDropDownOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteFromComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteFromComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'from';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteFromComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteFromComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteFromComponent,
      selectors: [["dxo-autocomplete-from"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteFromComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteFromComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteFromModule = /*#__PURE__*/(() => {
  class DxoAutocompleteFromModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteFromModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteFromModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteFromModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteFromComponent]
    });
  }
  return DxoAutocompleteFromModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteHideComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteHideComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'hide';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteHideComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteHideComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteHideComponent,
      selectors: [["dxo-autocomplete-hide"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteHideComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteHideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteHideModule = /*#__PURE__*/(() => {
  class DxoAutocompleteHideModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteHideModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteHideModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteHideModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteHideComponent]
    });
  }
  return DxoAutocompleteHideModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiAutocompleteItemComponent = /*#__PURE__*/(() => {
  class DxiAutocompleteItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiAutocompleteItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAutocompleteItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiAutocompleteItemComponent,
      selectors: [["dxi-autocomplete-item"]],
      inputs: {
        disabled: "disabled",
        html: "html",
        template: "template",
        text: "text",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiAutocompleteItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiAutocompleteItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiAutocompleteItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiAutocompleteItemModule = /*#__PURE__*/(() => {
  class DxiAutocompleteItemModule {
    /** @nocollapse */static ɵfac = function DxiAutocompleteItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAutocompleteItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiAutocompleteItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiAutocompleteItemComponent]
    });
  }
  return DxiAutocompleteItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteMyComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteMyComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'my';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteMyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteMyComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteMyComponent,
      selectors: [["dxo-autocomplete-my"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteMyComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteMyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteMyModule = /*#__PURE__*/(() => {
  class DxoAutocompleteMyModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteMyModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteMyModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteMyModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteMyComponent]
    });
  }
  return DxoAutocompleteMyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteOffsetComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'offset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteOffsetComponent,
      selectors: [["dxo-autocomplete-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteOffsetModule = /*#__PURE__*/(() => {
  class DxoAutocompleteOffsetModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteOffsetComponent]
    });
  }
  return DxoAutocompleteOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteOptionsComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteOptionsComponent extends NestedOption {
    renderer;
    document;
    element;
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useSubmitBehavior() {
      return this._getOption('useSubmitBehavior');
    }
    set useSubmitBehavior(value) {
      this._setOption('useSubmitBehavior', value);
    }
    get validationGroup() {
      return this._getOption('validationGroup');
    }
    set validationGroup(value) {
      this._setOption('validationGroup', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'options';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteOptionsComponent,
      selectors: [["dxo-autocomplete-options"]],
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        icon: "icon",
        onClick: "onClick",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        rtlEnabled: "rtlEnabled",
        stylingMode: "stylingMode",
        tabIndex: "tabIndex",
        template: "template",
        text: "text",
        type: "type",
        useSubmitBehavior: "useSubmitBehavior",
        validationGroup: "validationGroup",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoAutocompleteOptionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoAutocompleteOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteOptionsModule = /*#__PURE__*/(() => {
  class DxoAutocompleteOptionsModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteOptionsComponent]
    });
  }
  return DxoAutocompleteOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompletePositionComponent = /*#__PURE__*/(() => {
  class DxoAutocompletePositionComponent extends NestedOption {
    get at() {
      return this._getOption('at');
    }
    set at(value) {
      this._setOption('at', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get boundaryOffset() {
      return this._getOption('boundaryOffset');
    }
    set boundaryOffset(value) {
      this._setOption('boundaryOffset', value);
    }
    get collision() {
      return this._getOption('collision');
    }
    set collision(value) {
      this._setOption('collision', value);
    }
    get my() {
      return this._getOption('my');
    }
    set my(value) {
      this._setOption('my', value);
    }
    get of() {
      return this._getOption('of');
    }
    set of(value) {
      this._setOption('of', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get _optionPath() {
      return 'position';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompletePositionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompletePositionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompletePositionComponent,
      selectors: [["dxo-autocomplete-position"]],
      inputs: {
        at: "at",
        boundary: "boundary",
        boundaryOffset: "boundaryOffset",
        collision: "collision",
        my: "my",
        of: "of",
        offset: "offset"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompletePositionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompletePositionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompletePositionModule = /*#__PURE__*/(() => {
  class DxoAutocompletePositionModule {
    /** @nocollapse */static ɵfac = function DxoAutocompletePositionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompletePositionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompletePositionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompletePositionComponent]
    });
  }
  return DxoAutocompletePositionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteShowComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteShowComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'show';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteShowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteShowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteShowComponent,
      selectors: [["dxo-autocomplete-show"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteShowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteShowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteShowModule = /*#__PURE__*/(() => {
  class DxoAutocompleteShowModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteShowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteShowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteShowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteShowComponent]
    });
  }
  return DxoAutocompleteShowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutocompleteToComponent = /*#__PURE__*/(() => {
  class DxoAutocompleteToComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'to';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutocompleteToComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteToComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutocompleteToComponent,
      selectors: [["dxo-autocomplete-to"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutocompleteToComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutocompleteToComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutocompleteToModule = /*#__PURE__*/(() => {
  class DxoAutocompleteToModule {
    /** @nocollapse */static ɵfac = function DxoAutocompleteToModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutocompleteToModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutocompleteToModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutocompleteToComponent]
    });
  }
  return DxoAutocompleteToModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiAutocompleteToolbarItemComponent = /*#__PURE__*/(() => {
  class DxiAutocompleteToolbarItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get toolbar() {
      return this._getOption('toolbar');
    }
    set toolbar(value) {
      this._setOption('toolbar', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get _optionPath() {
      return 'toolbarItems';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiAutocompleteToolbarItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAutocompleteToolbarItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiAutocompleteToolbarItemComponent,
      selectors: [["dxi-autocomplete-toolbar-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        toolbar: "toolbar",
        visible: "visible",
        widget: "widget"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_toolbarItems,
        useExisting: DxiAutocompleteToolbarItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiAutocompleteToolbarItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiAutocompleteToolbarItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiAutocompleteToolbarItemModule = /*#__PURE__*/(() => {
  class DxiAutocompleteToolbarItemModule {
    /** @nocollapse */static ɵfac = function DxiAutocompleteToolbarItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAutocompleteToolbarItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiAutocompleteToolbarItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiAutocompleteToolbarItemComponent]
    });
  }
  return DxiAutocompleteToolbarItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiAutocompleteButtonComponent, DxiAutocompleteButtonModule, DxiAutocompleteItemComponent, DxiAutocompleteItemModule, DxiAutocompleteToolbarItemComponent, DxiAutocompleteToolbarItemModule, DxoAutocompleteAnimationComponent, DxoAutocompleteAnimationModule, DxoAutocompleteAtComponent, DxoAutocompleteAtModule, DxoAutocompleteBoundaryOffsetComponent, DxoAutocompleteBoundaryOffsetModule, DxoAutocompleteCollisionComponent, DxoAutocompleteCollisionModule, DxoAutocompleteDropDownOptionsComponent, DxoAutocompleteDropDownOptionsModule, DxoAutocompleteFromComponent, DxoAutocompleteFromModule, DxoAutocompleteHideComponent, DxoAutocompleteHideModule, DxoAutocompleteMyComponent, DxoAutocompleteMyModule, DxoAutocompleteOffsetComponent, DxoAutocompleteOffsetModule, DxoAutocompleteOptionsComponent, DxoAutocompleteOptionsModule, DxoAutocompletePositionComponent, DxoAutocompletePositionModule, DxoAutocompleteShowComponent, DxoAutocompleteShowModule, DxoAutocompleteToComponent, DxoAutocompleteToModule };
